import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { Container } from '../primitives';
import { tokens } from '../../config/themeTokens';

const HeaderEl = styled.header`
  background-color: ${tokens.colors.background};
  border-bottom: 1px solid ${tokens.colors.border};
  padding: ${tokens.spacing.md} 0;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${tokens.spacing.lg};
`;

const NavLink = styled(Link)`
  font-family: ${tokens.typography.fontFamily};
  font-size: ${tokens.typography.sizeSm};
  font-weight: ${({ $active }) => ($active ? tokens.typography.weightBold : tokens.typography.weightMedium)};
  color: ${({ $active }) => ($active ? tokens.colors.primary : tokens.colors.textMuted)};
  text-decoration: none;
  text-transform: uppercase;

  &:hover {
    color: ${tokens.colors.primary};
  }
`;

const Brand = styled(NavLink)`
  font-weight: ${tokens.typography.weightBold};
  text-transform: none;
`;

export function SiteHeader() {
  const location = useLocation();
  const base = '/twentytwentysix';

  return (
    <HeaderEl>
      <Container>
        <Nav>
          <Brand to={base} $active={location.pathname === base || location.pathname === `${base}/`}>
            TwentyTwentysix (preview)
          </Brand>
          <NavLink to={`${base}/`} $active={location.pathname === base || location.pathname === `${base}/`}>
            Home
          </NavLink>
          <NavLink to={`${base}/resources`} $active={location.pathname === `${base}/resources`}>
            Resources
          </NavLink>
          <NavLink to={`${base}/podcasts`} $active={location.pathname === `${base}/podcasts`}>
            Podcasts
          </NavLink>
          <NavLink to={`${base}/events`} $active={location.pathname === `${base}/events`}>
            Events
          </NavLink>
          <NavLink to={`${base}/membership`} $active={location.pathname === `${base}/membership`}>
            Membership
          </NavLink>
          <NavLink to={`${base}/about`} $active={location.pathname === `${base}/about`}>
            About
          </NavLink>
          <NavLink to={`${base}/collective`} $active={location.pathname === `${base}/collective`}>
            Collective
          </NavLink>
          <NavLink to={`${base}/login`} $active={location.pathname === `${base}/login`}>
            Login
          </NavLink>
        </Nav>
      </Container>
    </HeaderEl>
  );
}

export default SiteHeader;
